import {Grid} from "@mui/material"
import {ModalSeeker} from "@ui-seeker/core"
import GroupedExportsModalTable from "Pages/Admin/GroupedExports/Modal/Table"
import React from "react"
import {useGroupedExportsModal} from "../@hooks"
import {groupedExportsModalId} from "../@signals"

export default function GroupedExportsModal() {
	const { data, isLoading } = useGroupedExportsModal()

	if ( !groupedExportsModalId.value) return null

	return <ModalSeeker
		controller={() => groupedExportsModalId.value = null}
		isOpen={ !!groupedExportsModalId.value}
		hideActions
		containerProps={{
			maxWidth: "lg",
			p: 2,
		}}
	>
		<Grid container spacing={2}>
			<Grid item xs={12}>
				<GroupedExportsModalTable data={data} isLoading={isLoading}/>
			</Grid>
		</Grid>

	</ModalSeeker>
}